var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-centered my-col"},[_c('div',{staticClass:"column bg-div",class:_vm.myClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }